module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.input,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "可选控件类型",
      "prop": "allow_type"
    }
  }, [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.control.allow_type),
      expression: "curInput.control.allow_type"
    }],
    domProps: {
      "value": (_vm.curInput.control.allow_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.control.allow_type = $event
      }
    }
  }, _vm._l((_vm.inputTypes), function(item, index) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0517eb06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/paramsConfig.vue
// module id = 1760
// module chunks = 2